import React from 'react'
import { Icon,Tag } from 'antd';
import '../../css/svr_review_react.css'
const _ = require('lodash')

const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );
const HeartIcon = props => <Icon component={HeartSvg} {...props} />;


const getHotelAmenityList=(ar)=>{
        
        
    ar = ar || []
   return ar.map( (v, idx)=>{
       if(v.toLocaleLowerCase() == "swimming beach"){
        return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
    
       }else if(v.toLocaleLowerCase() == "tennis"){  
        return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
    

       }else if(v.toLocaleLowerCase() == "water"){  
        return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
    

       }else{

        return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
    
       }
      })
   


}

export default  (props)=>{
    const {my_data_review} = props
    let booking = null, svr_location, soj, rating_info, rating_text, rating_num
        let amenity_name = []

        if(my_data_review && my_data_review.booking){
            booking = my_data_review.booking
            soj = my_data_review.hotel
            let review = my_data_review.review
             svr_location = {
                "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                "county": soj['sojourn_city'] ? soj['sojourn_city'] : "albanyt",
                "postalcode":soj['postalCode'] ? soj['postalCode'] : 12193,
                "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                "country": soj['country_name'] ? soj['country_name'] : "usa",
               "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
               "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                
               "num_reviews":review['num_reviews'] ? review['num_reviews'] : 10,
               "state":soj['stateCode'] ? soj['stateCode'] : "NY"

            }
            rating_text = soj['sv_rating'] ? soj['sv_rating']: 'Excelellent'
            rating_num = soj['avg_stars_rating'] ? soj['avg_stars_rating']: 5
            rating_info = rating_text + ' Location -- ' + rating_num
        }
        if(booking && booking.en_activity_name_lvl && booking.en_activity_name_lvl.length > 0){

            amenity_name = booking.en_activity_name_lvl
        }else if(my_data_review && my_data_review.amenity_name && my_data_review.amenity_name.length > 0){
            amenity_name = my_data_review.amenity_name
        }

    //body start
    return (
        <div className="rev-row ">
            
        <div className="card card--raised with-shadow">
        
            
       
    <p className="sd-check"><text>Hotel </text></p>
    <p className="sd-content"> <text>{svr_location.SOJOURN_NAME? svr_location.resort_name:'Hotel Monreale Express International Drive Orlando' }   </text></p>
    <p className="sd-check"> <text> {svr_location.address_line1}, {svr_location.county}, {svr_location.postalcode} , {svr_location.country} 
                   </text>
    </p>
    <p className="sd-rating"> <text style={{fontSize:'12px', fontWeight:'300'}}>{rating_info? rating_info:'Excellent, 9.1' }   </text></p>
    
    <p className="sd-numreview">  <span style={{fontSize: "14px"}} ><Tag color="magenta">5.0</Tag> <text ><span style={{paddingLeft: "10px"}}>{booking? booking.num_reviews_label: 'Good , '}</span> <span> {svr_location.num_reviews} Reviews </span></text></span></p>
    
    
     
    <div className="box-left-listhotels">
                                       
                                        <p className="m-para-text">
                                       
                                            {getHotelAmenityList(booking.en_activity_name_lvl)}
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Wifi</text></span>
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Bath tub</text></span>
                                            
                                            
                                        </p>
    </div>
   

    </div>
    
</div>
)
}